import styles from './question.module.scss';

export default function Question({text}){
  return (
    <span className={styles["question"]} dangerouslySetInnerHTML={{ __html : text}}>
    </span>
  )
}
